import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DASHBOARD_URL } from '../env';
import LanguageSwitcher from './LanguageSwitcher';

export default function Navbar() {
  const { t } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  const featureLink = isHome ? '#features' : '/#features';
  const howLink = isHome ? '#how-it-works' : '/#how-it-works';
  const pricingLink = isHome ? '#pricing' : '/#pricing';

  return (
    <nav className="sticky top-0 z-50 border-b border-slate-800/50 bg-slate-950/80 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <Link to="/" className="text-xl font-display font-bold tracking-tight">
          <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
            {t('brand')}
          </span>
        </Link>

        {/* Desktop links */}
        <div className="hidden items-center gap-8 md:flex">
          <a href={featureLink} className="text-sm text-slate-400 hover:text-slate-100 transition-colors">
            {t('nav.features')}
          </a>
          <a href={howLink} className="text-sm text-slate-400 hover:text-slate-100 transition-colors">
            {t('nav.howItWorks')}
          </a>
          <a href={pricingLink} className="text-sm text-slate-400 hover:text-slate-100 transition-colors">
            {t('nav.pricing')}
          </a>
        </div>

        <div className="hidden items-center gap-4 md:flex">
          <LanguageSwitcher />
          <a
            href={`${DASHBOARD_URL}/login`}
            className="text-sm text-slate-400 hover:text-slate-100 transition-colors"
          >
            {t('nav.signIn')}
          </a>
          <a
            href={`${DASHBOARD_URL}/register`}
            className="rounded-lg bg-emerald-500 px-4 py-2 text-sm font-medium text-slate-950 hover:bg-emerald-400 transition-colors"
          >
            {t('nav.getStarted')}
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden text-slate-400 hover:text-slate-100"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label={t('nav.toggleMenu')}
        >
          {mobileOpen ? (
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="border-t border-slate-800/50 px-6 py-4 md:hidden">
          <div className="flex flex-col gap-4">
            <a
              href={featureLink}
              className="text-sm text-slate-400 hover:text-slate-100"
              onClick={() => setMobileOpen(false)}
            >
              {t('nav.features')}
            </a>
            <a
              href={howLink}
              className="text-sm text-slate-400 hover:text-slate-100"
              onClick={() => setMobileOpen(false)}
            >
              {t('nav.howItWorks')}
            </a>
            <a
              href={pricingLink}
              className="text-sm text-slate-400 hover:text-slate-100"
              onClick={() => setMobileOpen(false)}
            >
              {t('nav.pricing')}
            </a>
            <hr className="border-slate-800/50" />
            <LanguageSwitcher />
            <hr className="border-slate-800/50" />
            <a
              href={`${DASHBOARD_URL}/login`}
              className="text-sm text-slate-400 hover:text-slate-100"
            >
              {t('nav.signIn')}
            </a>
            <a
              href={`${DASHBOARD_URL}/register`}
              className="rounded-lg bg-emerald-500 px-4 py-2 text-center text-sm font-medium text-slate-950 hover:bg-emerald-400"
            >
              {t('nav.getStarted')}
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
